module.exports = __webpack_public_path__ + "img/big-pointer--primary.0ec8ba61.svg";